// extracted by mini-css-extract-plugin
export default {"link":"Filtered_link__wN85a","list":"Filtered_list__tsHZE"};